import { Route } from '@tanstack/router'
import { Outlet } from '@tanstack/router'

import { rootRoute } from '../root'

export const sponsorsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: 'sponsors',
  component: Outlet,
})
